export { default } from './EditGridPage';
